import { render } from "./App.vue?vue&type=template&id=3dc2a67a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3dc2a67a&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__